export var Status;
(function (Status) {
    Status["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    Status["UNPAID"] = "UNPAID";
    Status["PAID"] = "PAID";
    Status["EXPIRED"] = "EXPIRED";
    Status["VOIDED"] = "VOIDED";
})(Status || (Status = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["UNKNOWN_PAYMENT_METHOD"] = "UNKNOWN_PAYMENT_METHOD";
    /** Manual payment. */
    PaymentMethod["MANUAL"] = "MANUAL";
})(PaymentMethod || (PaymentMethod = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map